import { FormControl, FormErrorMessage } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { useController } from "react-hook-form";
import { getObjValueFromPath } from "../../utils";
import EsgFormLabel from "./EsgFormLabel";

// TODO This vs MultiSelect -- standardize code
// This is uses react-hook-form and has more features 
// Perhaps this can be refactored to use MultiSelect inside
function FormMultiSelect({
                           control,
                           name,
                           id,
                           label,
                           rules,
                           options,
                           errors,
                           containerStyles = {},
						   color,
                           ...props
                         }) {
  const {
    field: { onChange, onBlur, value, ref }
  } = useController({
    name,
    control,
    rules
  });

  const error = getObjValueFromPath(name, errors);

  const selectedOption = [];
  if (value && options) {
    value.forEach(selectedValObj => {
      const foundOption = options.find(opt => opt.value === selectedValObj.value);
      if (foundOption) {
        selectedOption.push(foundOption);
      }
    });
  }

  return (
    <FormControl isInvalid={error} id={id}>
      {label && (
        <EsgFormLabel
          htmlFor={id}
          color={color}
        >
          {label}
        </EsgFormLabel>
      )}

      <Select
        name={name}
        ref={ref}
        onBlur={onBlur}
        options={options}
        value={selectedOption}
        onChange={(option) => onChange(option)}
        isMulti
        {...props}
        className="chakra-react-select"
        classNamePrefix="chakra-react-select"
        chakraStyles={{
          dropdownIndicator: (provided) => ({
            ...provided,
            bg: "transparent",
            px: 2,
            cursor: "inherit"
          }),
          indicatorSeparator: (provided) => ({
            ...provided,
            display: "none"
          }),
          container: (provided) => ({
            ...provided,
            marginBlockStart: "1",
            fontSize: "md",
            fontWeight: "normal",
            textTransform: "initial",
            letterSpacing: "initial",
            ...containerStyles
          }),
          control: (provided) => ({
            ...provided,
            // borderRadius: "none"
          }),
          menuList: (provided) => ({
            ...provided,
            // borderRadius: "none",
            minWidth: "100%"
          }),
          option: (provided) => ({
            ...provided,
            _hover: {
              backgroundColor: "gray.100"
            },
          })
        }}
      />

      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </FormControl>
  );
}

export default FormMultiSelect;
